import React, {useState} from 'react';
import PropTypes from 'prop-types';
import UserInfoService from "services/AccountInfo/";
import Moment from 'moment';
import StorageService from 'services/StorageService';
import Link  from 'components/Link';
import Loader from 'components/Loader';
import style from './style.scss';

const TermsAndConditions = ({close}) => {
    const [checked, setChecked] = useState(true);
    const [isLoading, setLoading] = useState(false);

    const onChange = (event) => {
        if(event.target.checked) {
            setChecked(true);
        } else {
            setChecked(false);
        }
        
    }

    const click = () => {
        
        let terms = {
            terms_acceptance_date: Moment().format()
        };

        if(checked) {
            setLoading(true);
            UserInfoService.updateUser(terms).then(() => {
                let data = StorageService.getSecureItem('userData');
                data.terms_acceptance_date = terms.terms_acceptance_date;
                StorageService.setSecureItem('userData', data);
                setLoading(false);
                setTimeout(() => {
                    close();
                }, 500);
            })
        }
    }

    return (
        <div className='new-modal-container terms-and-conditions'>
            <div className={'new-modal-scroll'}>
                <h1 className="new-modal-title">Cambio en Términos y Condiciones</h1>
                <h3 className="terms-and-conditions-subtitle">Cargos en Tarjeta de Crédito</h3>
                <p className="terms-and-conditions-paragraph">Cuando el cliente realiza un pedido en Jumbo.cl o Jumbo App, la primera transacción que verá en los movimientos no facturados de su tarjeta de crédito será un cargo transitorio, equivalente al monto del pedido ingresado. El cargo o cobro definitivo lo observará una vez que el pedido haya sido recolectado.</p>
                <p className="terms-and-conditions-paragraph">Si hubiera alguna diferencia entre el pedido original y el pedido recolectado que recibirá, entonces el cliente verá una segunda transacción en su tarjeta, también en los movimientos no facturados, esta vez correspondiente a la devolución de la diferencia, la que se efectuará en un máximo de 3 días hábiles. En caso de inconvenientes, como por ejemplo algún bloqueo de la tarjeta, la devolución podría demorar un poco más, pero en ningún caso exceder los 14 días corridos.</p>
                <p className="terms-and-conditions-paragraph last-paragraph-terms">Si no existieran diferencias entre el pedido original y el recolectado, sólo verá la primera transacción en los movimientos de su tarjeta de crédito.</p>
            </div>
            <div className="modal-actions">
                <label className="terms-and-conditions-cont-check">
                    <input type="checkbox" name='terms-and-conditions' checked={checked} onChange={(event) => onChange(event)}/>    
                    <span className="terms-and-conditions-accept">Acepto los nuevos los <Link target={"_blank"} to="/institucional/terminos-condiciones" className="terms-and-conditions-link">Términos y condiciones</Link></span>
                </label>
                
                <button className={checked ? "primary-btn" : "disabled-btn"} onClick={click}>
                    {!isLoading && 'Confirmar'}
                    {isLoading && <span className="terms-and-conditions-loader"><Loader/></span>}
                </button>
            </div>
        </div>
    )
}

TermsAndConditions.propTypes = {
    close: PropTypes.func
}

export default TermsAndConditions;